@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../packing-recommend/packing-applied.module.less';

.inputs-container {
  gap: @space-8;
}

.size-input {
  flex: 1;
}

@import '../packing-recommend/packing-applied-classes.module.less';

.packing-applied-input {
  .packing-applied-input-styles();
}
